import { FormFieldDto, FormFieldType } from '../../general/dtos';

export function isMultiChoiceType(type: FormFieldType): boolean {
    return type === 'checkbox-group' || type === 'multi-select';
}

export function selectionKeys(value: unknown): string[] {
    return Array.isArray(value) ? Array.from(new Set(value.filter((item): item is string => typeof item === 'string'))) : [];
}

export function selectionLabels(field: FormFieldDto, value: unknown): string {
    return selectionKeys(value).map(key => field.options?.find(option => option.key === key)?.value ?? key).join(', ');
}

export function selectionsMatch(actual: unknown, expected: unknown): boolean {
    const actualKeys = selectionKeys(actual).sort();
    const expectedKeys = selectionKeys(expected).sort();
    return actualKeys.length === expectedKeys.length && actualKeys.every((key, index) => key === expectedKeys[index]);
}

export function selectionScore(actual: unknown, expected: unknown): number | null {
    if (!Array.isArray(expected)) return null;
    const actualKeys = selectionKeys(actual);
    const expectedKeys = new Set(selectionKeys(expected));
    const denominator = Math.max(actualKeys.length, expectedKeys.size);
    return denominator === 0 ? 1 : actualKeys.filter(key => expectedKeys.has(key)).length / denominator;
}

export function hasExpectedAnswer(value: unknown, type?: FormFieldType): boolean {
    return Array.isArray(value) || (typeof value === 'string' && (type === 'inline-text' || value.trim().length > 0));
}

export function expectsBlankInline(type: FormFieldType, value: unknown): boolean {
    return type === 'inline-text' && typeof value === 'string' && value.trim() === '';
}
